import { LinkedRecordsService } from "./LinkedRecordsService";
import { API_HOST_LINKEDRECORDS } from "../config";

export const linkedRecordsService = new LinkedRecordsService(API_HOST_LINKEDRECORDS);
